module.exports = __webpack_public_path__ + "static/media/slide1.c5cba92b.jpg";